import request from "@/utils/request";

import { objToParam } from "@/utils/index";

// << 离职单-待办 分 5个类型填信息

// >> 离职单-待办 分 5个类型填信息

// 串休单，兼岗判断
export function checkConPostTime(data) {
  return request({
    url: `/ade/checkConPostTime`,
    method: "post",
    data
  });
}

// 流程撤回
export function RevokeRejectJump(data) {
  return request({
    url: `/process/service/RevokeRejectJump`,
    method: "post",
    data
  });
}

// 已办撤回
export function completedRevoke(data) {
  return request({
    url: `/process/service/completed/revoke`,
    method: "post",
    data
  });
}

// 终止流程
export function hangUp(data) {
  return request({
    url: "/process/service/hangUp",
    method: "post",
    data
  });
}

// 查询审批意见
export function findHandleOpinion(data) {
  return request({
    url: `/process/service/findHandleOpinion`,
    method: "post",
    data
  });
}

// 审批操作
export function complete(data) {
  return request({
    url: `/process/service/complete`,
    method: "post",
    data
  });
}

// 【【 入职申请
//选择保险单
export function insurancePage(data) {
  return request({
    url: `/org/employers/insurance/page`,
    method: "post",
    data
  });
}

// 发起 入职申请单 流程
export function launchProcess(data) {
  data.clientType = "web";
  return request({
    url: `/process/service/start`,
    method: "post",
    data
  });
}

// 事项列表
export function todoPageWeb(data) {
  return request({
    url: `/process/todoPageWeb`,
    method: "post",
    data
  });
}
export function getOAMaopao() {
  return request({
    url: `/ws/wflow/process/instance/count`,
    method: "get",
    
  });
}
export function getGreenMaopao(parameter) {
  let paramStr = objToParam(parameter)

  return request({
    url: `/green/curing/task-execution/getProcessNum` + paramStr,
    method: "get",
    
  });
}
//清洁接单冒泡
export function getJobDescriptionMaopao() {
  return request({
    url: `/recruit/rec/job-description/maopao`,
    method: "get",
  });
}
//清洁接单冒泡
export function getCleanOrderMaopao() {
  return request({
    url: `/green/ven/clean-order/getNum?status=1&projectId=0`,
    method: "get",
  });
}
export function getQualityMaopao(parameter) {
  return request({
    url: `/quality/quClientInspection/waitingCount/${parameter}`,
    method: "get",
  });
}
//事项列表导出
export function incompleteExport(data) {
  return request({
    url: `/process/incompleteExport`,
    method: "post",
    data
  });
}

// 请假单 获取当月已请假日期
export function findUserLeaveDaysOffCount(data) {
  return request({
    url: `/ade/findUserLeaveDaysOffCount`,
    method: "post",
    data
  });
}

// 请假单 获取当月已请假班次
export function getRecordWorkCycle(data) {
  return request({
    url: `/ade/getRecordWorkCycle`,
    method: "post",
    data
  });
}

// 补助单 校验历史
export function duplicateCheck(data) {
  return request({
    url: `/ade/paySanctionRecord/duplicateCheck`,
    method: "post",
    data
  });
}
export function checkHoldingRecord(data) {
  return request({
    url: `/ade/checkHoldingRecord`,
    method: "post",
    data
  });
}

// 考勤异常单 获取考勤时间
export function findAdeGroupBreakWorkTime(data) {
  return request({
    url: `/ade/findAdeGroupBreakWorkTime`,
    method: "post",
    data
  });
}

// 修改提交
export function stayhairMatterCompl(data) {
  return request({
    url: `/process/service/stayhairMatterCompl`,
    method: "post",
    data
  });
}

// 获取复职信息
export function findUserByIdNumber(data) {
  return request({
    url: `/org/findUserByIdNumber`,
    method: "post",
    data
  });
}

// 获取黑名单
export function findByIdNumber(data) {
  return request({
    url: `/org/blackUser/findByIdNumber`,
    method: "post",
    data
  });
}

// 】】 入职申请

// 【【  事项 列表
// 1 待发事项
export function stayhairMatter(data) {
  return request({
    url: `/process/service/stayhairMatter`,
    method: "post",
    data
  });
}
// 待发删除
export function stayhairDel(id) {
  return request({
    url: `/process/stayhair/del/${id}`,
    method: "get"
  });
}

// 2 已发事项
export function alreadyissued(data) {
  return request({
    url: `/process/service/alreadyissued`,
    method: "post",
    data
  });
}

// 3 待办事项 page limit userId
export function taskList(data) {
  return request({
    url: `/process/service/taskList`,
    method: "post",
    data
  });
}
// 4 终止事项 page limit userId
export function stopProcess(data) {
  return request({
    url: `/process/service/stopProcess`,
    method: "post",
    data
  });
}
// 4-1 终止事项删除 page limit userId
export function delAlreadydone(id) {
  return request({
    url: `/process/delAlreadydone/${id}`,
    method: "get",
  });
}

// 3-1 供应链待办事项 page limit userId
export function taskListhrGyl(data) {
  return request({
    url: `/process/service/taskListhrGyl`,
    method: "post",
    data
  });
}

// 4 已办事项 page limit userId
export function alreadydone(data) {
  return request({
    url: `/process/service/alreadydone`,
    method: "post",
    data
  });
}
// 知会事项
export function findNotifyByDynamic(data) {
  return request({
    url: `/process/service/findNotifyByDynamic`,
    method: "post",
    data
  });
}
// 知会提交
export function updateNotifyState(data) {
  return request({
    url: `/process/service/updateNotifyState`,
    method: "post",
    data
  });
}
// 】】 事项 列表

// 单据管理
export function businessSingle(data) {
  return request({
    url: `/process/service/businessSingle`,
    method: "post",
    data
  });
}

export function paySanctionPage(data) {
  return request({
    url: `/process/service/paySanctionPage`,
    method: "post",
    data
  });
}

// 流程终止  processInstanceId
export function getProcessInfo(data) {
  return request({
    url: `/process/service/getProcessInfo`,
    method: "post",
    data
  });
}

// 流程终止  processInstanceId
export function getTemplatefo(id) {
  return request({
    url: `/process/service/getTemplatefo?processInstanceId=${id}`,
    method: "get"
  });
}

// 获取销假记录
export function getLeaveRecords(data) {
  return request({
    url: `/ade/getLeaveRecords`,
    method: "post",
    data
  });
}

// 串休 - 时间校验

export function breakRecordDateCheck(data) {
  return request({
    url: `/ade/breakRecordDateCheck`,
    method: "post",
    data
  });
}

// 增岗名称校验
export function addPostCheck(data) {
  return request({
    url: `/org/addPostCheck`,
    method: "post",
    data
  });
}

// 兼岗单校验 员工是否可以兼岗
export function staffConPostCheck(userId) {
  return request({
    url: `/org/staffConPostCheck/${userId}`,
    method: "get"
  });
}

// 加班单时间校验
export function overtimeProve(data) {
  return request({
    url: `/ade/overtime/prove`,
    method: "post",
    data
  });
}

// 单据查询 查详情
export function findFromDetailsByProcessId(data) {
  return request({
    url: `/process/service/findFromDetailsByProcessId`,
    method: "post",
    data
  });
}

// 入职流程前 调用接口
export function saveUserAndInf(data) {
  return request({
    url: `/org/saveUserAndInf`,
    method: "post",
    data
  });
}
// 撤销 入职
export function delUserByPhone(data) {
  return request({
    url: `/org/delUserByPhone`,
    method: "post",
    data
  });
}

// 增岗直接生效
export function savePostByForm(data) {
  return request({
    url: `/org/savePostByForm`,
    method: "post",
    data
  });
}
// 增岗撤销
export function delOrgPostByLabel(data) {
  return request({
    url: `/org/delOrgPostByLabel`,
    method: "post",
    data
  });
}

// 获取暂扣发记录
export function findHoldingRecord(data) {
  return request({
    url: `/ade/findHoldingRecord`,
    method: "post",
    data
  });
}

// 取消特殊考勤单，校验
export function checkStateAtt(data) {
  return request({
    url: `/ade/checkStateAtt`,
    method: "post",
    data
  });
}

// 事项列表
export function listAllTask(data) {
  return request({
    url: `/process/service/listAllTask`,
    method: "post",
    data
  });
}
// 待办列表
export function todoPage(page,limit,tableType,beginDate,endDate,userId,label, taskFlowBeginTime='',taskFlowEndTime="") {
  return request({
    url: `/process/todo/page?page=${page}&limit=${limit}&tableType=${tableType}&applyBeginTime=${beginDate}&applyEndTime=${endDate}&userId=${userId}&label=${label}&taskFlowBeginTime=${taskFlowBeginTime}&taskFlowEndTime=${taskFlowEndTime}`,
    method: "get",
    // data
  });
}
// 待办列表导出
export function todoExport(tableType,beginDate,endDate,userId,label, taskFlowBeginTime='',taskFlowEndTime="") {
  return request({
    url: `/process/todo/export-excel?tableType=${tableType}&applyBeginTime=${beginDate}&applyEndTime=${endDate}&userId=${userId}&label=${label}&taskFlowBeginTime=${taskFlowBeginTime}&taskFlowEndTime=${taskFlowEndTime}`,
    method: "get",
    responseType:'blob'
    // data
  });
}

// 根据 员工ids 获取 员工信息列表
export function findUserPostLabelByUserIds(data) {
  return request({
    url: `/org/findUserPostLabelByUserIds`,
    method: "post",
    data
  });
}

// 根据岗位职务,返回是否可以见习  oldPostId-原岗位,newPostId-新岗位,userId-员工id
export function checkPromotion(data) {
  return request({
    url: `/org/checkPromotion`,
    method: "post",
    data
  });
}

// 查询节点状态
export function findNodeAttribute(data) {
  return request({
    url: `/process/findNodeAttribute`,
    method: "post",
    data
  });
}

// 查询当天兼岗排班岗位信息
export function findUserConPostIdByGoWorkDate(userId, date) {
  return request({
    url: `/org/findUserConPostIdByGoWorkDate/${userId}/${date}`,
    method: "get"
  });
}
// 查询婚丧假冒泡
export function aaaa(date) {
  return request({
    url: `/org/aaaa`,
    method: "get"
  });
}